import * as React from 'react';
import Link from '@mui/material/Link';


const tap151Link = "https://tap151.com";

type Tap151LinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: Tap151LinkProps = {
  linkText: "Tap 151 Bar & Grill",
  underline: "hover"
};

export default function Tap151Link(linkProps: Tap151LinkProps = defaultProps) {
  return (
          <Link href={tap151Link} 
            underline={linkProps.underline ? linkProps.underline : defaultProps.underline}
            >
            {linkProps.linkText ? linkProps.linkText : defaultProps.linkText}
          </Link>
  );
}